import { useQueryClient } from "@tanstack/react-query";

import usePartMutations from "../../../data/usePartMutations";
import useDefaultCRUDHandlers from "../../../hooks/useDefaultCRUDHandlers";
import { IPart } from "../../../models/Part";
import classNames from "../../../utils/classNames";


export default function UnlistedGradeUpdate({ part }: { part: IPart }) {
  const { patchPart } = usePartMutations();
  const { saveHandlers } = useDefaultCRUDHandlers("Part Grade");

  const handleGradeUpdate = (grade: string) => {
    const patchBody = {
      id: part.id,
      grade: grade,
    };

    if (part.grade === grade) return;
    if (!grade) return;

    patchPart.mutate(patchBody, {
      ...saveHandlers,
      onSuccess: () => {
        // queryClient.invalidateQueries(["pagedTable"]);
        saveHandlers.onSuccess();
        part.grade = grade.toUpperCase(); // Update the part's grade in the local state
      }
    });
  }

  return (
    <div className="" onClick={(e) => e.stopPropagation()}>

      <input
        key={part.id}
        defaultValue={part.grade ?? ""}
        className={classNames("w-full text-xs h-6 border p-1 ")}
        type="text"
        onBlur={(e) => handleGradeUpdate(e.target.value)}
      />

    </div>
  )
}